import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Alert, Box, Button, Tab, Tabs } from '@mui/material';

import { Event } from '~/services/CorporateEventsService';

interface EventFormHeaderProps {
  tab: string;
  event?: Event;
  onBack: () => void;
  onTabChange: (tab: string) => void;
  hasUnsavedChanges?: boolean;
  isCreateMode?: boolean;
}

export default function EventFormHeader({
  tab,
  event,
  onBack,
  onTabChange,
  hasUnsavedChanges = false,
  isCreateMode = false,
}: EventFormHeaderProps) {
  const title = event?.id ? `Edit Event: ${event.name}` : 'Create Event';
  const shouldBlockTabs = isCreateMode || hasUnsavedChanges;

  const handleTabChange = (_: React.SyntheticEvent, newTab: string) => {
    if (shouldBlockTabs && newTab !== 'details') {
      return; // Prevent tab change
    }
    onTabChange(newTab);
  };

  return (
    <>
      <Box mb={3} display="flex" justifyContent="space-between" alignItems="center">
        <Box display="flex" gap={2} alignItems="center">
          <Button variant="text" startIcon={<ArrowBackIcon />} onClick={onBack}>
            Back to List
          </Button>
          <Box component="h2" m={0}>
            {title}
          </Box>
        </Box>
      </Box>
      {shouldBlockTabs && tab === 'details' && (
        <Alert severity="info" sx={{ mb: 2 }}>
          {isCreateMode
            ? 'Please save the event details first before accessing other tabs.'
            : 'Please save your changes before accessing other tabs.'}
        </Alert>
      )}
      <Box borderBottom={1} borderColor="divider" component="div">
        <Tabs value={tab} onChange={handleTabChange}>
          <Tab value="details" label="Event Details" />
          <Tab value="custom-questions" label="Custom Questions" disabled={shouldBlockTabs} />
          {event && <Tab value="invited-users" label="Invited Users" disabled={shouldBlockTabs} />}
        </Tabs>
      </Box>
    </>
  );
}
